export const ObjectFit = {
  CONTAIN: 'contain',
  COVER: 'cover',
} as const;
